import React, {useEffect, useState} from "react";
import {DurationHHMMSS} from "../../../helper/dateTime";

export function Countdown({ endTime, disable, javascriptTimestamp = false }) {
    if(!javascriptTimestamp) {
        endTime *= 1000;
    }
    const [ timeLeft, setTimeLeft ] = useState(endTime - Date.now())

    useEffect(() => {
        if(disable) {
            return;
        }
        const interval = setInterval(() => {
            setTimeLeft(endTime - Date.now());
        }, 1000);

        return () => {
            clearInterval(interval);
        }
    }, [endTime, disable]);

    return <>
        {DurationHHMMSS(Math.floor(timeLeft / 1000))}
    </>
}

export function Time({ time, javascriptTimestamp = false }) {
    if(!javascriptTimestamp) {
        time *= 1000;
    }
    const timeString = new Date(time).toLocaleTimeString();
    return <>
        {timeString}
    </>
}